// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import { withRouter } from "react-router";
import classnames from "classnames";
import { Link, Page } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./InsufficientPriviledges.m.scss";

// connecting component to the redux store
@withRouter
@themr("InsufficientPriviledges", styles)
export default class InsufficientPriviledges extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    location: PropTypes.object,
  };

  render() {
    const { theme, location } = this.props;
    const { state } = location;
    return (
      <Page header={"Недостаточно прав"}>
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>
            <div className={classnames(theme.inner)}>
              <div className={classnames(theme.intro)}>
                {"Вы попытались получить доступ к"}
              </div>
              {state.reason && state.reason.targetName ? (
                <div className={classnames(theme.message)}>
                  {state.reason.targetName}
                </div>
              ) : state.reason && state.from ? (
                <div className={classnames(theme.domain)}>{`${
                  window.location.protocol
                }//${window.location.hostname}${state.from.pathname}`}</div>
              ) : null}
              <div className={classnames(theme.intro)}>{"Причина отказа:"}</div>
              {state.reason && state.reason.message ? (
                <div className={classnames(theme.message)}>
                  {state.reason.message}
                </div>
              ) : null}
              <Link
                type={"alt"}
                to={"/"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                {"Вернуться на главную"}
              </Link>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/InsufficientPriviledges/InsufficientPriviledges.js